<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-2">
      <div class="section-title mb-2">
        {{ $t("add") }} {{ $t("cash") }} {{ $t("card") }}
      </div>
      <router-link class="btn-blue" :to="{ name: 'Cash Cards' }"
        >{{ $t("cash") }} {{ $t("card") }} {{ $t("lists") }}</router-link
      >
    </div>

    <div class="white-wrapper">
      <div class="row" v-for="(cashCard, index) in cashCardsArray" :key="index" v-if="index == 0">
        <div class="col-lg-6 col-xl-4 mb-2 pl-4">
          <div class="row">
            <!-- 3 8 1 -->
            <div class="col-md-2 mb-2 mr-1 p-0">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    id="prefix"
                    name="prefix"
                    v-model="cashCard.prefix"
                    maxlength="3"
                    minlength="1"
                    placeholder="xxx"
                    type="text"
                    v-on:keydown="
                  e => {
                    if (!/[0-9]/.test(e.key) && e.keyCode !== 8) {
                      e.preventDefault();
                    }
                  }
                "
                  />
                  <label>{{ $t('prefix') }}</label>
                </div>
              </div>
            </div>
            <div class="col-md-6 mb-4 mr-1 p-0">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    id="randomIdentifier"
                    name="randomIdentifier"
                    v-model="cashCard.randomIdentifier"
                    :disabled="true"
                    placeholder="xxxxxxxx"
                    type="text"
                    v-on:keydown="
                  e => {
                    if (!/[0-9]/.test(e.key) && e.keyCode !== 8) {
                      e.preventDefault();
                    }
                  }
                "
                  />
                  <label>{{ $t('random_card_number') }}</label>
                </div>
              </div>
            </div>
            <div class="col-md-2 mb-4 mr-1 p-0">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    id="suffix"
                    name="suffix"
                    v-model="cashCard.suffix"
                    placeholder="x"
                    maxlength="1"
                    type="text"
                    v-on:keydown="
                  e => {
                    if (!/[0-9]/.test(e.key) && e.keyCode !== 8) {
                      e.preventDefault();
                    }
                  }
                "
                  />
                  <label>{{ $t('suffix') }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-2 col-xl-2 mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
              style="text-align:right;"
                id="pin"
                name="pin"
                v-model="cashCard.cash_card_pin"
                v-validate="'required'"
                placeholder="Enter Pin"
                maxlength="4"
                type="text"
                 v-on:keydown="
                  e => {
                    if (!/[0-9]/.test(e.key) && e.keyCode !== 8) {
                      e.preventDefault();
                    }
                  }
                "
              />
              <label>{{ $t('pin') }}</label>
            </div>
            <!-- <Tooltip :title="$t('Passcode')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('pin')"
              >{{ errors.first("pin") }}
            </span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="issuer"
                name="issuer"
                v-validate="'required'"
                v-model="cashCard.issuer"
                placeholder="Card Issuer"
              />
              <label>{{ $t('issuer') }}</label>
            </div>
            <!-- <Tooltip :title="$t('issuer')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('issuer')"
              >{{ errors.first("issuer") }}
            </span>
          </p>
        </div>

<div class="col-lg-2 col-xl-2 mb-2 pt-2">
          <div class="d-flex align-items-center">
           <b-form-checkbox
                type="checkbox"
                class="j-checkbox"
                v-model="cashCard.cash_card_is_active"
                true-value="Y"
                false-value="N"
              />

            <label class="mb-0 mr-3">{{ $t("active") }}</label>
            
             
              
            </label>
          </div>
        </div>

         <div class="col-lg-6 col-xl-4 mb-2">
          <div class="row">
            <div class="col-10">
              <div class="d-flex align-items-center">
                <label
                  class="material-file-upload"
                  @click.prevent.stop="setModalData(637.5, 1011)"
                >
                  <div class="text-truncate p-2">
                    {{
                      cashCard.cash_card_image
                        ? cashCard.cash_card_image
                        : "Please Select Image"
                    }}
                  </div>
                </label>
                <!-- <Tooltip
                  :title="`Artwork to be displayed on Cash Card`"
                /> -->
              </div>
            </div>
            <div class="col-2 align-self-center p-0">
              <img
                width="40"
                height="40"
                class="rounded c-pointer img-preview"
                :src="_GetImagePath(cashCard.cash_card_image)"
                v-if="cashCard.cash_card_image"
              />
              <img
                v-else
                width="35"
                height="35"
                class="rounded"
                alt="Empty Image"
                src="@/assets/img/icons/empty-image.svg"
              />
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 mb-2">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <multiselect
                :options="customers"
                :searchable="true"
                :placeholder="
                  selected_customer && selected_customer.length > 0
                    ? selected_customer
                    : 'Customer'
                "
                label="temp_customer_name"
                track-by="track_id"
                @select="onSelectCustomer($event)"
                @remove="onRemoveCustomer($event)"
                :showLabels="false"
              >
              <span slot="noResult">Oops! No Results found.</span>
            <span slot="option" slot-scope="props"
              >{{ props.option.temp_customer_name }}<br><div class="tagEmail">{{props.option.hasOwnProperty('guest_id') ?props.option.guest_email : props.option.cust_email }}</div>
              <p class="tagText" v-if="props.option.guest_id">
                Guest
              </p></span
            >
              </multiselect>
            </div>
            <!-- <Tooltip :title="$t('selected_customer')" /> -->
          </div>
          <p class="error_message">
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <!-- @focus="onFocusHandler" -->
              <!-- :required="item.required" -->
              <input
                id="initial_amount"
                name="initial_amount"
                v-validate="'required|numeric'"
                v-model="cashCard.initial_amount"
                placeholder="."
              />
              <label>{{ $tc("initialamount") }}</label>
            </div>
            <!-- <Tooltip :title="$t('initial_amount')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('initial_amount')"
              >{{ $tc("initial_amount") }}
            </span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-2">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label
                :class="credited_by && credited_by.length > 0 ? 'shift-up' : ''"
                >{{ $tc("creditedby") }}</label
              >
              <b-dropdown
                disabled
                :text="credited_by"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(user, userIndex) in userList"
                  href="#"
                  :key="userIndex"
                  name="userDropdown"
                  id="userDropdown"
                  v-on:click="onSelectUser(user)"
                  >{{ user.first_name }} {{ user.last_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <!-- <Tooltip :title="$t('credited_by')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && credited_by.length == 0"
              >Please Select User</span
            >
          </p>
        </div>

        <div class="col-lg-6 col-xl-8 ">
              <div class="input-material-textarea">
              <textarea
                id="remarks"
                name="remarks"
                v-model="cashCard.remarks"
                placeholder="."
                rows="2"
              ></textarea>
              <label>{{ $t("remarks") }}</label>
              </div>
            </div>

      


          <div class="d-flex align-items-center col-12 new-border back rounded-10 mb-2">
        <div class="mb-2 pt-2">
          <div class="d-flex align-items-center">
            <b-form-checkbox
                class="j-checkbox pb-0 mb-0"
                v-model="isBulk"
                @change="OnChangeMultipleCodeGenerate"
                
              ></b-form-checkbox>
              <span class="ml-1">{{ 'Generate Mulitple Card' }}</span>
          </div>
          
        </div>
      
      
      
      
            <div class="col-md-4 mb-2 pt-3" v-if="isBulk == true ">
              <div class="input-material">
                <input
                  v-model="quantity"
                  id="card_quantity"
                  name="card_quantity"
                  placeholder="."
                  type="text"
                  v-validate="isBulk ? 'required' : ''"
                  v-on:keydown="
                  e => {
                    if (!/[0-9]/.test(e.key) && e.keyCode !== 8) {
                      e.preventDefault();
                    }
                  }
                "
                />
                <label>{{ $t("total") }} {{ $t("number") }}</label>
              </div>
              <p class="error_message">
            <span v-if="submitted && errors.has('card_quantity')"
              >{{ errors.first("card_quantity") }}
            </span>
          </p>
            </div>
          </div>
          </div>

      <div class="text-center">
        <button @click.prevent.stop="addCashCard()" class="btn-blue">
          {{ $t("save_n_generate") }}
        </button>
      </div>
    </div>
    <ImageGallery
      v-bind:propImageName="'Cash Card Artwork'"
      v-bind:openModal="showModal"
      v-bind:set_height="set_height"
      v-bind:set_width="set_width"
    ></ImageGallery>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import MarketingService from "@/services/MarketingService";
import { mapGetters } from "vuex";
import ImageGallery from "@/components/Pages/ImageGallery/imageGalleryModal";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { generateRandomCode, UniqueRandomNumber } from "@/helper/collection";

export default {
  components: { VueCropper, ImageGallery },
  data() {
    return {
      isBulk: false,
      quantity: null,
      cashCardsArray: [
        {
        prefix: '100',
        randomIdentifier: UniqueRandomNumber(),
        suffix: '1',
        cash_card_visible: '',
        cash_card_reason: '',
        cash_card_quantity: null,
        cash_card_pin: generateRandomCode(4),
        cash_card_type: '',
        cash_card_image: '',
        issuer: '',
        cash_card_number: null,
        card_number_with_spaces: null,
        customer_id: null,
        guest_id: null,
        initial_amount: 0,
        remarks: '',
        credited_by: null,
        cash_card_is_active: 'Y'
      }
      ],
      set_height: null,
      set_width: null,
      showModal: false,
      submitted: false,
      cash_card_number: "",
      card_number_with_spaces: "",
      selected_customer: "",
      customer_id: null,
      guest_id: null,
      initial_amount: null,
      credited_by: null,
      user_id: null,
      cash_card_is_active: "Y",
      customerList: [],
      userList: []
    };
  },
  beforeMount() {
    this.getCashCardIdentifier();
  },
  mounted() {
    let user_id = this.secureStore.get("USINFO").user_id;
    this.getUserList(user_id);
    this.getCustomerList();
    this.getGuestCustomers();
    this.cashCardsArray[0].issuer = this.getOrganizationDetails ? this.getOrganizationDetails.org_name : ''
  },
  computed: {
    ...mapGetters(["finalImagePath", "getOrganizationDetails"]),
    customers() {
      this.customerList.forEach((x, index) => {
        x['track_id'] = `c-${index}`
        x['temp_customer_name'] = this.setLabel(x);
      })
      return this.customerList
    }
  },
  watch: {
    finalImagePath(newval) {
      console.log("newval", newval)
      this.cashCardsArray[0].cash_card_image = newval;
    }
  },
  methods: {
    OnChangeMultipleCodeGenerate: function() {
      if (
        this.isBulk
      ) {
        //Generate random PIN and Add +1 to the unique code
      }
    },
    setModalData(height, width) {
      this.set_height = height;
      this.set_width = width;
      this.showModal = !this.showModal;
    },
     setLabel(event) {
       let text = ``;
       if(event.hasOwnProperty('guest_id') && event.guest_id) {
text = `${event.guest_first_name && String(event.guest_first_name) !== 'null' ? event.guest_first_name : ""} ${
        event.guest_last_name && String(event.guest_last_name) !== 'null' ? event.guest_last_name : ""
      }`
       } else {
         text = `${event.first_name && String(event.first_name) !== 'null' ? event.first_name : ""} ${
        event.last_name && String(event.last_name) !== 'null' ? event.last_name : ""
      }`
       }
      return text;
    },
    onSelectCustomer(customer) {
      
      if(customer.hasOwnProperty('guest_id') && customer.guest_id) {
        this.selected_customer = `${
        customer.guest_first_name ? customer.guest_first_name : ""
      } ${customer.guest_last_name ? customer.guest_last_name : ""}`;

        this.guest_id = customer.guest_id
        this.customer_id = null
      } else {
        this.selected_customer = `${
        customer.first_name ? customer.first_name : ""
      } ${customer.last_name ? customer.last_name : ""}`;
        
        this.customer_id = customer.cust_id;
        this.guest_id = null;
      }
    },
    onRemoveCustomer(customer) {
       this.customer_id = null;
       this.guest_id = null;
       this.selected_customer = ''
    },
    onSelectUser(user) {
      this.credited_by = `${user.first_name} ${user.last_name}`;
      this.user_id = user.user_id;
      this.cashCardArray[0].credited_by = user.user_id
    },
    getGuestCustomers() {
      let payload = {
        tableName: "guest_customers"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.customerList = this.customerList.concat(data.Records);
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getCustomerList: function() {
      let payload = {
        tableName: "customers",
        cust_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.customerList = this.customerList.concat(data.Records);
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getUserList: function(user_id) {
      let payload = {
        tableName: "users",
        is_active: "Y",
        user_id: user_id
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.userList = data.Records;
            this.userList.map(x => {
              if (x.user_id == user_id) {
                this.credited_by = `${x.first_name} ${x.last_name}`;
                this.user_id = x.user_id;
              }
            });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getCashCardIdentifier: function() {
      MarketingService.GetCashCardIdentifier()
        .then(response => {
          const { data } = response;
          if (data.status && data.cashCardIndentifier) {
            this.cashCardsArray[0].randomIdentifier = data.cashCardIndentifier
          } else {
            console.log("show error :", data.message);
          }
        })
        .catch((err) => {
          console.log("Error:", err)
        });
    },
    addCashCard() {
      this.submitted = true;
      let isError = false;
      let errorMessage = ``
      this.$validator.validate().then(valid => {
        if (valid) {
          this.cashCardsArray.forEach((x) => {
            if(!x.prefix) {
              isError = true;
              errorMessage = 'Card Prefix is Required.'
            } else if(!x.randomIdentifier) {
              isError = true;
              errorMessage = 'Card Identifier is Required.'
            } else if(!x.suffix) {
              isError = true;
              errorMessage = 'Card Suffix is Required.'
            } else {
              x['card_number_with_spaces'] = x.prefix + " " + x.randomIdentifier + " " + x.suffix;
              x['cash_card_number'] = x.prefix + x.randomIdentifier + x.suffix;
              x['cash_card_visible'] = x.prefix + " " + x.randomIdentifier + " " + x.suffix;
              x['cash_card_quantity'] = this.quantity;
              x['cash_card_type'] = this.isBulk ? 'Multiple' : 'Single';
              x['customer_id'] = this.customer_id;
              x['guest_id'] = this.guest_id;
              x['credited_by'] = this.user_id;
            }
          })

          if(isError) {
              return this.$toasted.show(errorMessage);
          } else if (this.isBulk && !this.quantity) {
              return this.$toasted.show('Please Enter Quantity for Multiple Cash Cards');
          } else {
          let loader = this.$loading.show();

          let payload = {
            isBulk: this.isBulk,
            card_quantity: this.quantity,
            cashCardArray: this.cashCardsArray,
            cash_card_number: this.cashCardsArray[0].cash_card_number,
            cash_card_identifier: this.cashCardsArray[0].randomIdentifier,
          };
          MarketingService.AddCashCard(payload)
            .then(response => {
              const { data } = response;
              loader.hide();
              if (data && data.status) {
                this.$toasted.show(data.message);

                this.$router.push({
                  path: "/marketing/cash-cards"
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
          }
        } else {
          this.$toasted.show("Please enter all details");
        }
      });
    }
  }
};
</script>
<style>
.tagText {
  position: absolute;
  right: 15px;
  top: 10px;
  font-size: 10px !important;
}

.tagEmail {
  font-size: 9px !important;
}
.new-border{
  border: 2px solid #b1b4b8;
}
label{
  color: black !important;
}
.internal-border-new{
  border: 1px solid #3876d2;
/*background-color: #e6e6f8;*/
}
.internal-border{
border: 1px solid #3876d2;
background-color: #e6e6f8;
display: flex;
flex-wrap: wrap;
border-radius: 10px;
margin: 0 15px 15px 15px;
padding-top:15px;
}
.fs{
  font-size: 17px;
}
.back{
  background-color: #f5f5f5;
}
.mar{
  margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/CashCardComponents/addCashCard.vue